// IMClient
export const UNREAD_MESSAGES_COUNT_UPDATE = 'unreadmessagescountupdate';
export const CLOSE = 'close';
export const CONFLICT = 'conflict';
export const CONVERSATION_INFO_UPDATED = 'conversationinfoupdated';
export const UNHANDLED_MESSAGE = 'unhandledmessage';

// shared
export const INVITED = 'invited';
export const KICKED = 'kicked';
export const MEMBERS_JOINED = 'membersjoined';
export const MEMBERS_LEFT = 'membersleft';
export const MEMBER_INFO_UPDATED = 'memberinfoupdated';
export const BLOCKED = 'blocked';
export const UNBLOCKED = 'unblocked';
export const MEMBERS_BLOCKED = 'membersblocked';
export const MEMBERS_UNBLOCKED = 'membersunblocked';
export const MUTED = 'muted';
export const UNMUTED = 'unmuted';
export const MEMBERS_MUTED = 'membersmuted';
export const MEMBERS_UNMUTED = 'membersunmuted';
export const MESSAGE = 'message';
export const MESSAGE_RECALL = 'messagerecall';
export const MESSAGE_UPDATE = 'messageupdate';

// Conversation
export const LAST_DELIVERED_AT_UPDATE = 'lastdeliveredatupdate';
export const LAST_READ_AT_UPDATE = 'lastreadatupdate';
export const INFO_UPDATED = 'infoupdated';
